import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

const Header = lazy(() => import('./components/Header'));
const Footer = lazy(() => import('./components/Footer'));
const Hero = lazy(() => import('./components/Hero'));
const InfoSections = lazy(() => import('./components/InfoSections'));
const NuestrasAreasBanner = lazy(() => import('./components/NuestrasAreasBanner'));
const MissionVisionPurpose = lazy(() => import('./components/MissionVisionPurpose'));
const TeamSection = lazy(() => import('./components/TeamSection'));
const ContactPage = lazy(() => import('./components/ContactPage'));
const ServiciosPage = lazy(() => import('./components/ServiciosPage'));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: 'ease-out-cubic',
      once: true,
    });
  }, []);

  return (
    <Router>
      <Suspense fallback={<div className="loading">Cargando...</div>}>
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Hero />
              <InfoSections />
              <NuestrasAreasBanner />
              <MissionVisionPurpose />
              <TeamSection />
              <Footer />
            </>
          }/>
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/contacto" element={<ContactPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
